import axios from "axios";
import {base_url} from '../constants/constants';
import * as auth_actions from '../components/authentication/AuthenticationAction';

// Set config defaults when creating the instance
// const instance = axios.create({
//   baseURL: base_url,
// });

const token = localStorage.getItem("token");
const employeeId = JSON.parse(localStorage.getItem("state"))?.AuthenticationReducer.userId;
const station = JSON.parse(localStorage.getItem("state"))?.AuthenticationReducer.station;

// instance.defaults.headers.common["Authorization"] = 'Bearer ' + token;
//instance.defaults.headers.post['Content-Type'] = 'application/json';
//instance.defaults.timeout = 30000;

// instance.interceptors.response.use(response => {
//   return response;
// }, error => {
//   return Promise.reject(error);
// });

// export default instance;
axios.defaults.headers.common["Authorization"] = 'Bearer ' + token;

const instance_api = (type, url, data, headers, responseType) => {
  axios.defaults.headers.common['X-EMPID'] = employeeId;
  axios.defaults.headers.common['X-STATION'] = station;
  const options = {
    method: type,
    url: url,
    responseType: responseType,
    headers:
    {
      fileFormat: headers
    }
    // headers: {
    //   'Content-Type': 'application/json',
    //   'Access-Control-Allow-Origin': true,
    //   'withCredentials': false,
    //   'Access-Control-Allow-Credentials': true,
    // },
  }
  if (data) {
    options.data = data;
  }

  return axios(options)
    .then((response) => {
      return response;
    })
    .catch((error) => {
       if(error.toString().includes('401')){
         auth_actions.logoutSuccess();
         return {code:401}
       }
       else{
        return error;
       }
    })
};

export default instance_api;

